/* Atelier Valtis — animations « Roulez, pompez, c'est levé » (cric hydraulique 2 T à roulettes). 26/10/2026 */
(function(){
if(window.__avCricManuelAnim)return;window.__avCricManuelAnim=1;

/* Couleurs du cric (photo produit) */
const BL='#2f40a3', BLD='#1b2a7a', YE='#f5c400', BK='#1e2128', BG='#f6f8fb', GREEN='#2fae5b', NAVY='#1d2433';
const D=Math.PI/180;
const clamp=v=>Math.max(0,Math.min(1,v));
const ease=t=>t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;
const seg=(p,a,b)=>ease(clamp((p-a)/(b-a)));
const lerp=(a,b,t)=>a+(b-a)*t;

function badge(x,y,txt,color,op=1,sc=1){
  const w=txt.length*6.3+22;
  return `<g opacity="${op}" transform="translate(${x+w/2},${y+11}) scale(${sc}) translate(${-w/2},-11)">
  <rect width="${w}" height="22" rx="11" fill="${color||NAVY}"/>
  <text x="${w/2}" y="15" text-anchor="middle" font-size="11" font-weight="700" fill="#fff" font-family="Manrope,sans-serif">${txt}</text></g>`;
}

/* Cric rouleur hydraulique (profil). tx = décalage horizontal, h = hauteur sellette 0..1, ha = angle du levier */
const S=1.2, TY=222-176*S;
function geo(h){const a=(-12-h*30)*D;return {sx:88+62*Math.cos(a), sy:160+62*Math.sin(a)};}
function jack(tx,h,ha,roll=0){
  const {sx,sy}=geo(h), r=Math.PI-ha*D;
  const hx=58+42*Math.cos(r), hy=156+42*Math.sin(r), gx=58+30*Math.cos(r), gy=156+30*Math.sin(r);
  const wheel=(cx)=>`<circle cx="${cx}" cy="170" r="6.5" fill="${BK}"/><circle cx="${cx}" cy="170" r="2.6" fill="#a7afbd"/>
    <line x1="${cx}" y1="170" x2="${cx+5*Math.cos(roll)}" y2="${170+5*Math.sin(roll)}" stroke="#a7afbd" stroke-width="1.3"/>`;
  const svg=`<g transform="translate(${tx},${TY}) scale(${S})">
    <ellipse cx="104" cy="176" rx="62" ry="2.6" fill="#000" opacity=".08"/>
    <line x1="58" y1="156" x2="${hx}" y2="${hy}" stroke="${BL}" stroke-width="4.5" stroke-linecap="round"/>
    <line x1="${gx}" y1="${gy}" x2="${hx}" y2="${hy}" stroke="${BK}" stroke-width="7" stroke-linecap="round"/>
    <path d="M48 166 L160 166 L160 158 L66 149 L48 149 Z" fill="${BL}" stroke="${BLD}" stroke-width="1.5" stroke-linejoin="round"/>
    <rect x="50" y="137" width="20" height="19" rx="3" fill="${BLD}"/>
    <line x1="88" y1="156" x2="${sx}" y2="${sy}" stroke="${BLD}" stroke-width="10" stroke-linecap="round"/>
    <line x1="88" y1="156" x2="${sx}" y2="${sy}" stroke="${BL}" stroke-width="7.5" stroke-linecap="round"/>
    <rect x="${sx-3}" y="${sy-5}" width="6" height="6" fill="${BK}"/>
    <rect x="${sx-11}" y="${sy-10}" width="22" height="6" rx="2" fill="${BK}"/>
    <path d="M84 150 V136 Q84 131 89 131 H101 Q106 131 106 136 V152" fill="none" stroke="${YE}" stroke-width="4" stroke-linecap="round"/>
    <rect x="86" y="150" width="22" height="7" rx="1" fill="${YE}"/>
    ${wheel(58)}${wheel(150)}
  </g>`;
  return {svg, tip:[hx*S+tx, hy*S+TY], top:(sy-10)*S+TY, sx:sx*S+tx};
}

/* Bas de caisse de la voiture (identique au cric électrique) */
function car(lift,jx){
  const y=156-lift;
  return `<g>
    <path d="M-10 ${y-170} H330 V${y} H-10Z" fill="#dfe4ec"/>
    <path d="M-10 ${y-170} H330 V${y-96} H-10Z" fill="#cfd6e1"/>
    <line x1="70" y1="${y-96}" x2="70" y2="${y-14}" stroke="#c3cad6" stroke-width="2"/>
    <rect x="96" y="${y-62}" width="22" height="5" rx="2.5" fill="#b4bdca"/>
    <rect x="-10" y="${y-14}" width="340" height="14" fill="#b4bdca"/>
    <circle cx="262" cy="${y+32}" r="46" fill="${BG}"/>
    <g transform="translate(262,${188-lift})">
      <circle r="34" fill="#2a2f3a"/><circle r="19" fill="#a7afbd"/><circle r="6" fill="#6f7888"/>
      ${[0,72,144,216,288].map(a=>`<rect x="-2.5" y="-18" width="5" height="12" rx="2" fill="#6f7888" transform="rotate(${a})"/>`).join('')}
    </g>
    <rect x="${jx-14}" y="${y}" width="28" height="5" rx="1.5" fill="#6f7888"/>
  </g>`;
}
const ground=`<rect x="0" y="222" width="320" height="40" fill="#e7ebf1"/><line x1="0" y1="222" x2="320" y2="222" stroke="#d3d9e2" stroke-width="2"/>`;
const wrap=c=>`<svg viewBox="0 0 320 300" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g transform="translate(0,46)">${c}</g></svg>`;

/* Flèche circulaire de la valve (cw = sens horaire) */
function valve(cx,cy,rot,col,cw){
  const p=cw?`M${cx-14} ${cy-16} A21 21 0 0 1 ${cx+20} ${cy-8}`:`M${cx+14} ${cy-16} A21 21 0 0 0 ${cx-20} ${cy-8}`;
  const hd=cw?`M${cx+12} ${cy-12} l8 4 l1 -9`:`M${cx-12} ${cy-12} l-8 4 l-1 -9`;
  return `<circle cx="${cx}" cy="${cy}" r="21" fill="none" stroke="${col}" stroke-width="1.6" stroke-dasharray="4 4"/>
  <g transform="rotate(${rot},${cx},${cy})"><path d="${p}" fill="none" stroke="${col}" stroke-width="3.5" stroke-linecap="round"/>
  <path d="${hd}" fill="none" stroke="${col}" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></g>`;
}
const arrow=(x,y,up,col,op=1)=>`<path d="M${x} ${y} v${up?-22:22} m-7 ${up?8:-8} l7 ${up?-9:9} l7 ${up?9:-9}" stroke="${col}" stroke-width="3.5" fill="none" stroke-linecap="round" stroke-linejoin="round" opacity="${op}"/>`;

const TX=-5, HMAX=1;
const liftOf=top=>Math.max(0,161-top);

const scenes=[
 // 1 · Fermez la valve
 {dur:4200, draw(p){
   const r=seg(p,.1,.6), ok=seg(p,.62,.72);
   const J=jack(30,0,-40); const [vx,vy]=J.tip;
   return wrap(`${ground}${J.svg}
    ${valve(vx,vy,r*300,ok>0?GREEN:NAVY,true)}
    ${badge(14,-32,'Sens horaire')}
    ${badge(178,40,'Valve fermée ✓',GREEN,ok,lerp(.6,1,ok))}`);
 }},
 // 2 · Positionnez
 {dur:4200, draw(p){
   const m=seg(p,.08,.5), a=seg(p,.52,.62), pulse=p>.52?(Math.sin((p-.52)*30)+1)/2:0;
   const tx=lerp(-200,TX,m), J=jack(tx,0,-40,(tx-TX)/6.5), sx=jack(TX,0,-40).sx;
   return wrap(`${ground}${car(0,sx)}
    <line x1="${sx}" y1="164" x2="${sx}" y2="${J.top-4}" stroke="${GREEN}" stroke-width="2" stroke-dasharray="4 4" opacity="${a}"/>
    <circle cx="${sx}" cy="158" r="${12+pulse*6}" fill="none" stroke="${GREEN}" stroke-width="2" opacity="${a*(1-pulse*.6)}"/>
    ${J.svg}
    ${badge(14,-32,'Point de levage constructeur')}
    ${badge(228,-32,'Aligné ✓',GREEN,a,lerp(.6,1,a))}`);
 }},
 // 3 · Pompez
 {dur:4800, draw(p){
   const u=clamp((p-.06)/.7), n=4, f=(u*n)%1, wave=(1-Math.cos(f*2*Math.PI))/2;
   const pumping=p>.06&&p<.76;
   const h=HMAX*ease(u), ha=pumping?-40-30*wave:-40;
   const J=jack(TX,h,ha), lift=liftOf(J.top), done=seg(p,.76,.86);
   const [tx,ty]=J.tip;
   return wrap(`${ground}${car(lift,J.sx)}${J.svg}
    <g opacity="${pumping?1:0}">${arrow(tx+30,ty+4,f<.5,GREEN)}</g>
    ${badge(14,-32,"Jusqu'à 2 tonnes")}
    ${badge(190,-32,'Roue décollée ✓',GREEN,done,lerp(.6,1,done))}`);
 }},
 // 4 · Redescendez
 {dur:4800, draw(p){
   const v=seg(p,.04,.28), d=seg(p,.26,.76), down=p>.26&&p<.78;
   const J=jack(TX,HMAX*(1-d),-40), lift=liftOf(J.top), done=seg(p,.78,.88);
   const [vx,vy]=J.tip;
   return wrap(`${ground}${car(lift,J.sx)}${J.svg}
    ${valve(vx,vy,-v*200,NAVY,false)}
    <g opacity="${down?1:0}">${arrow(J.sx,104-lift,false,NAVY)}</g>
    ${badge(14,-32,'Valve ouverte en douceur')}
    ${badge(212,-32,'Redescendu ✓',GREEN,done,lerp(.6,1,done))}`);
 }}
];

let running=false;
const vis=new Set();
function init(){
  const els=[...document.querySelectorAll('.av-cm-ill:not([data-ready])')];
  if(!els.length) return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io=new IntersectionObserver(es=>es.forEach(e=>e.isIntersecting?vis.add(e.target):vis.delete(e.target)),{threshold:.15});
  els.forEach(el=>{el.dataset.ready=1;io.observe(el);el.innerHTML=scenes[+el.dataset.scene].draw(.9);});
  if(reduce||running) return;
  running=true;
  const t0=performance.now();
  (function tick(now){vis.forEach(el=>{if(!el.isConnected){vis.delete(el);return;}const s=scenes[+el.dataset.scene];el.innerHTML=s.draw(((now-t0)%s.dur)/s.dur);});requestAnimationFrame(tick);})(t0);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
